/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { environment } from '../../../environments/environment';
import * as dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import { Observable, tap } from 'rxjs';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { CommonService } from '../../services/common.service';
import { EncryptionService } from '../../services/encryption.service';

dayjs.extend(utc);
dayjs.extend(tz);

@Injectable({
  providedIn: 'root'
})
export class SetInterceptor implements HttpInterceptor {
  private selectedLanguage = 'en';
  private apiEndpoints = ['/userPackages', '/packages'];
  constructor(
    private translate: TranslateService,
    private _authService: AuthService,
    private _encryptionSerivce: EncryptionService,
    private commonService: CommonService
  ) {
    this.commonService.selectedLanguage.subscribe({
      next: (res: string) => {
        this.selectedLanguage = res;
      }
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const clonedReq = this.handleRequest(req);
    return next.handle(clonedReq);
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  handleRequest(req: HttpRequest<any>) {
    const storageKey = localStorage.getItem(environment.storageKey);
    const token: string | null = storageKey ? storageKey : null;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, prefer-const
    let authReq: any;
    const headers: any = {
      authorization: token ? `Bearer ${token}` : '',
      // date: dayjs.default().valueOf().toString(),
      lang: this.selectedLanguage,
      'x-portal': 'web'
    };

    if (!req.url.includes('/media/uploadFile')) {
      headers['Content-Type'] = 'application/json';
    }

    if (req.url.includes('user/resetPassword')) {
      this._authService.resetTokenSubject.subscribe((res: string) => {
        if (res) {
          headers.authorization = `Bearer ${res}`;
        }
      });
    }

    const profile = this._authService.profileDetailsSubject.getValue();
    const query: any = {};
    if (!this.isApiAllowed(req.url) && profile) {
      query['role'] = profile.role;
    }
    // eslint-disable-next-line prefer-const
    authReq = req.clone({
      headers: new HttpHeaders({
        // hash: this._encryptionSerivce.encryptHeaders(headers),
        ...headers,
        deviceType: 'web',
        language: this.translate.currentLang || ''
      }),
      setParams: {
        ...query
      }
    });

    if (
      req.method.toLowerCase() === 'post' ||
      req.method.toLowerCase() === 'put' ||
      req.method.toLowerCase() === 'delete'
    ) {
      if (req.url.includes('/admin/media')) {
        // Do nothing
      } else {
        // authReq['body'] = {
        //   hash: this._encryptionSerivce.encryptionPayload(
        //     JSON.stringify(authReq.body)
        //   )
        // };
      }
    }
    return authReq;
  }

  isApiAllowed(fullUrl: string): boolean {
    try {
      const url = new URL(fullUrl);
      const apiEndpoint = url.pathname;
      return this.apiEndpoints.some((endpoint: string) => apiEndpoint === endpoint || apiEndpoint.startsWith(`${endpoint  }/`)
      );
    } catch (error) {
      console.error('Invalid URL:', fullUrl);
      return false;
    }
  }

}
